<template>
    <el-tooltip :content="tenantName" placement="right" effect="dark" :open-delay="openDelay">
        <div class="projectInfo" :class="projectInfoMini">
            <template v-if="customLogoPath != ''">
                <img class="logo" :src="require('@/assets/images/logo.jpg')" alt="">
            </template>
            <template v-else-if="tenantName != ''">
                <div class="tenant-avatar">
                    <!-- 主界面logo字 
                    <div class="tenant-avatar"><span>{{tenantName.charAt(0)}}</span></div>-->
                    <img class="logo" :src="logoPath_" alt="">
                </div>
            </template>
            <template v-else>
                <img class="logo" :src="logoPath_" alt="">
                <span class="projectName">{{logoMsg_.projectName}}</span>
            </template>
        </div>
    </el-tooltip>
</template>

<script>
import { envInfo } from '@/constants/envInfo'
export default {
    name:'LogoToggle',
    data () {
        return {
            openDelay: 1500,
            status:this.showStatus,
            logoMsg_: this.logoMsg,
            logoPath:[require('@/assets/images/defaultLogo.png'),require('@/assets/images/defaultLogo_icon.png')],
            logoPath_: require('@/assets/images/logo.png'),
            projectInfoMini:'',
        }
    },
    props: ['showStatus','logoMsg'],
    watch: {
        showStatus: {
            handler(status) {
                if (status) {
                    console.info(this.customLogoPath + "---"+ this.tenantName)
                    if(this.customLogoPath || this.tenantName) {
                        this.projectInfoMini = 'projectInfoMini';
                    } else {
                        this.logoPath_ = this.logoPath[1];
                        if (this.logoMsg_.logoFileName !== '') {
                            this.logoPath_ = require('@/assets/images/'+this.logoMsg_.logoFileName+'_icon.png')
                        }
                    }
                }else{
                    if(this.customLogoPath || this.tenantName) {
                        this.projectInfoMini = '';
                    } else {
                        this.logoPath_ = this.logoPath[0];
                        if (this.logoMsg_.logoFileName !== '') {
                            this.logoPath_ = require('@/assets/images/'+this.logoMsg_.logoFileName+'.png')
                        }
                    }
                }
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        customLogoPath() {
            let customLogo = this.$store.getters.constomLogo
            let customLogoPath = ''
            if(customLogo) {
                customLogoPath = envInfo.bgApp.tenantPath+"/param/tenant/avatar?p="+customLogo
            }
            return customLogoPath
        },
        tenantName() {
            let tenantList = this.$store.getters.tenantList
            let currentTenant = this.$store.getters.currentTenant
            if(currentTenant && tenantList) {
                for(let i =0; i < tenantList.length; i++) {
                    if(tenantList[i].tenantId == currentTenant) {
                        return tenantList[i].tenantName;
                    }
                }
            }
            return ''
        }
    }
}
</script>

<style>
    .projectInfo{
        /*padding: 10px 20px 0px;*/
        /*cursor: pointer;*/
        height: 60px;
    }

    .projectInfo .logo {
        width: 100%;
        height: 100%;
        border: none;
    }
    .projectInfo .projectName{
        display: block;
        font-size: 14px;
        text-align: center;
        color:rgb(191, 203, 217);
    }

    .projectInfo .tenant-avatar {
        height: 95%;
        width: 95%;
       
        
    }

    .projectInfo .tenant-font {
        color: #fcf9f9;
        overflow-x: hidden;
        position: relative;
        font-family: '微软雅黑',Arial,'宋体';
        vertical-align: top;
        line-height: 1.6;
        font-size: 36px;
        font-weight: 700
    }

    /* 收起后 */
    .projectInfoMini{
        padding: 0px;
    }
    .projectInfoMini .logo {
        width: 36px;
        height: 50px;
        display: block;
        margin: 0 auto;
    }
    .projectInfoMini .projectName{
        display: none;
    }

    .projectInfoMini .tenant-avatar {
        height: 2.5rem;
        width: 100%;
        display: inline-block;
        background: #5091f9;
        text-align: center;
        border-radius: 0px;
    }

    .projectInfoMini .tenant-font {
        color: #fcf9f9;
        overflow-x: hidden;
        position: relative;
        font-family: '微软雅黑',Arial,'宋体';
        vertical-align: top;
        line-height: 2.6;
        font-size: 17px;
        font-weight: 700
    }

</style>
